import React, { useState } from 'react'
import video from '../../assets/images/video.svg'
import { FiPlayCircle } from "react-icons/fi";
import videoFile from '../../assets/video/liberyus-video.mp4'



const VideoBanner = () => {

    const [showVideo, setShowVideo] = useState(false)
    const videoUrl = videoFile;

   
    return (
        <div className='video-banner' >
            {!showVideo && (

                    <video controls autoPlay muted>
                        <source src={videoUrl} type="video/mp4" />
                        
                    </video> 
                )} 
            
            {/* <img src={video} alt='' /> */}
            {/* <FiPlayCircle size={50} color='#EEF1FA' /> */}
        </div>
    )
}

export default VideoBanner
